import React, { useContext } from 'react';
import {
    BrowserRouter,
    Routes,
    Route
}
    from 'react-router-dom'
import { ClientNavigator } from '../../navigator/client.navigator';
import { DashboardScreen } from '../common/dashboard.screen';
import { LoginScreen } from '../admin/login.screen';
import { UserContext } from '../../App';
import { SignInScreen } from '../common/sign_in.screen';
export const ClientApp = () => {

    const { user, setUser } = useContext(UserContext);
    return <BrowserRouter>
        <Routes>
            {user.id ?
                <Route path="/" element={<DashboardScreen navigator={ClientNavigator()} />}>
                    {ClientNavigator().filter(F => F.parent === undefined).map(M => <Route path={`${M.link}`} element={M.page} />)}
                </Route> : [
                    <Route path="/sign-in" element={<SignInScreen />} />,
                    <Route path="/*" element={<LoginScreen />} />,
                ]}
        </Routes>
    </BrowserRouter>
}